import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "auth-form-container" }
const _hoisted_2 = { class: "auth-form" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { for: "username" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "password" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = {
  key: 0,
  class: "form-group"
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = {
  key: 1,
  class: "form-group"
}
const _hoisted_15 = { class: "email-input-wrapper" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 2,
  class: "form-group"
}
const _hoisted_18 = { type: "submit" }
const _hoisted_19 = { class: "email-input-wrapper" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.isLogin ? _ctx.$t("login.title") : _ctx.$t("register.title")), 1),
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("login.username")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authForm.username) = $event)),
              placeholder: !_ctx.isLogin ? _ctx.$t('login.usernamePlaceholder') : '',
              required: ""
            }, null, 8, _hoisted_5), [
              [_vModelText, _ctx.authForm.username]
            ]),
            (_ctx.usernameError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.usernameError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("login.password")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.authForm.password) = $event)),
              placeholder: !_ctx.isLogin ? _ctx.$t('login.passwordPlaceholder') : '',
              required: ""
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.authForm.password]
            ]),
            (_ctx.passwordError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.passwordError), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "confirmPassword" }, "确认密码", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  id: "confirmPassword",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.authForm.confirmPassword) = $event)),
                  placeholder: !_ctx.isLogin ? '' : '',
                  required: ""
                }, null, 8, _hoisted_12), [
                  [_vModelText, _ctx.authForm.confirmPassword]
                ]),
                (_ctx.passwordError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.passwordError), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "email" }, "邮箱", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "email",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.authForm.email) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.authForm.email]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendCaptcha(1))),
                    disabled: _ctx.isCountdown,
                    class: "captcha-button"
                  }, _toDisplayString(_ctx.countdown > 0 ? `${_ctx.countdown}s` : "获取验证码"), 9, _hoisted_16)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { for: "captcha" }, "验证码", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "captcha",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.authForm.captcha) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.authForm.captcha]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.isLogin ? _ctx.$t("login.submit") : _ctx.$t("register.submit")), 1)
        ], 32),
        _createElementVNode("p", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleAuthMode && _ctx.toggleAuthMode(...args)))
        }, _toDisplayString(_ctx.isLogin ? _ctx.$t("register.switch") : _ctx.$t("login.switch")), 1),
        _createElementVNode("p", {
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showPage && _ctx.showPage(...args)))
        }, "忘记密码")
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "忘记密码",
      width: "500",
      "destroy-on-close": "",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          "label-width": "auto",
          style: {"max-width":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "邮箱：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "验证码：" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "email",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.code) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.code]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendCaptcha(2))),
                    disabled: _ctx.isCountdown2,
                    class: "captcha-button"
                  }, _toDisplayString(_ctx.countdown2 > 0 ? `${_ctx.countdown2}s` : "获取验证码"), 9, _hoisted_20)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "新密码：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.password) = $event)),
                  type: "password"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "确认密码：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.confirmPassword,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                  type: "password"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.editPassword
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("确认")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      default: _withCtx(() => [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "" }, null, -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}